define(
  'app/views/grouped_ext_buy_button_view',['app/setup', 'app/views/add_to_cart_form_view', 'app/session', 'app/models/discount'],
  function (takhfifan, addToCart, session) {

    takhfifan.GroupedExtBuyButtonView = Backbone.View.extend({

      model: takhfifan.Discount,
      events: {
        'click .tkh-gebb': 'submit'
      },

      initialize: function (options) {
        if(options.customView) {
          this.customView = options.customView;
        }
        this.template = _.template($('#tkh-deal-item-template').html());
        var _this = this;
        this.vendorId = this.model.get('vendorId');

        takhfifan.eventHub.on('customer:verification', function (data) {
          this.customer = session.getCustomerVerificationData();
        }, this);

        this.model.on('change', this.render, this);

        takhfifan.eventHub.on('timeover:' + this.vendorId, function () {
          _this.disable();
        }, this);

        takhfifan.eventHub.on('groupedProduct:removeAssociate',
          function (opts) {
            if (_this.model.id === opts.productId) {
              _this.disable();
            }
          }, this);

        takhfifan.eventHub.on('dealseconds:' + this.model.get('id'), function(){
          _this.enable();
        });

        takhfifan.eventHub.on('dc:addToCart' + this.model.id, function(opts) {
          this.setAsLoading();
          takhfifan.eventHub.trigger('productaddtocart:' + this.model.id, this);
        }, this);

        takhfifan.eventHub.on('dc:checkoutProcess' + this.model.id, function(pid) {
          _this.checkoutProcess(pid);
        });

        takhfifan.eventHub.on('dc:showDcMultiUseModal' + this.model.id, function(code) {
          _this.showMultiUseCodeModal(code);
        }, this);

        takhfifan.eventHub.on('modal:disableTriggerElement', function(options) {
          this.enable()
        },this);

      },

      showMultiUseCodeModal: function(code){
        takhfifan.eventHub.trigger('modal:closeModalWithContent');
        takhfifan.eventHub.trigger('dc:multiUseModal' , {
          pid: this.model.id,
          vendorId: this.vendorId,
          partnerURL: this.model.get('partnerUrl'),
          title: this.model.get('name'),
          highlight: this.model.get('dealHighlights'),
          condition: this.model.get('dealCondition'),
          code: code,
        });
      },

      showFreeSingleCode: function (checkoutType, viewObject) {
        var _this = viewObject;
        if (session.customerIsLoggedIn()) {
          this.model.buyFreeSingleCoupon(_this.model.id, session.getCustomerData().email,
            function (data) {
              if (data && data.success) {
                _this.showMultiUseCodeModal(data.code);
              } else {
                takhfifan.eventHub.trigger('message:show', {
                  type: 'error',
                  msg: data.error
                });
              }
            });
        } else {
          takhfifan.eventHub.trigger('customer:loginForm');
        }
      },

      checkoutProcess: function () {
        var _this = this;
        this.model.getCheckoutType(takhfifan.formKey, this.checkUrl, function (checkoutType) {
          if (checkoutType.success) {
            if (checkoutType.type === 'cart') {
              takhfifan.eventHub.trigger('productaddtocart:' + _this.model.id, _this);
            } else if (checkoutType.type === 'free') {
              _this.showFreeSingleCode(checkoutType, _this);
            }else{
              _this.showMultiUseCodeModal(checkoutType.code);
            }
            _this.removeLoading();
          } else {
            takhfifan.eventHub.trigger('modal:closeModalWithContent');
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: checkoutType.error
            });
            _this.removeLoading();
          }
        });
      },

      render: function () {
        if(!this.customView) {
          this.$el.html(this.fillTempalte());
        }
        this.updateItemStatus();
        if (this.model.get('isSoldOut') || this.model.get('expired') || this.model.get('seconds') <= 0) {
          this.disable();
        }
      },

      fillTempalte: function () {
        var sortOrder = 3;
        var isLimited = this.model.get('maxPerOrder') < 10;
        var typeClass = "dc-item--normal tkh-dc-deal-filter--normal";
        switch (this.model.get('dealType')) {
          case "1":
            typeClass = "dc-item--exclusive tkh-dc-deal-filter--exclusive";
            sortOrder = 1;
            break;
          case "2":
            typeClass = "dc-item--user tkh-dc-deal-filter--user";
            sortOrder = 2;
            break;
        }

        return this.template({
          productId: this.model.get('id'),
          dealType: this.model.get('dealType'),
          name: this.model.get('name'),
          countView: this.model.get('countView'),
          dealHighlights: this.model.get('dealHighlights'),
          shortTitle: this.model.get('shortTitle'),
          discountPercentage: this.model.get('discountPercentage'),
          couponBadgeContent: this.model.get('couponBadgeContent'),
          productLike: this.model.get('productLike'),
          sortOrder: sortOrder,
          typeClass: typeClass,
          isLimited: isLimited,
        });
      },

      updateItemStatus: function () {

        this.$btn = this.$el.find('.tkh-gebb');
        this.$groupedExtBuyButton =  this.$el.find('.tkh-grouped-ext-buy-button');
        this.$loadingWrapper = this.$el.find('.tkh-ge-wrap');
        this.checkUrl = $('#tkh-check-customer-can-buy-url').val();
        this.isLimited = this.$groupedExtBuyButton.data('isLimited');
        if (session.sessionHasData()) {
          this.customer = session.getCustomerVerificationData();
          this.enable();
        } else {
          takhfifan.eventHub.on('customer:verification', function (data) {
            this.customer = session.getCustomerVerificationData();
            this.enable();
          }, this);
        }
        this.generateAddToCartForm();
      },

      generateAddToCartForm: function () {
        var $form = $('<form />').prop({
          method: 'post',
          action: '#'
        }).css('display', 'none');

        this.$groupedExtBuyButton.append($form);
        new takhfifan.AddToCartFormView({el: $form, productId: this.model.id});

        //model already fetched...
        if (!_.isUndefined(this.model.get('seconds'))) {
          takhfifan.eventHub.trigger('dealseconds:' + this.model.get('id'), parseInt(this.model.get('seconds')));
          takhfifan.eventHub.trigger('cartinfo:' + this.model.get('id'), this.model);

          if (this.model.get('isSoldOut')) {
            takhfifan.eventHub.trigger('buyButton:soldOut', this.model);
          }
        }
      },

      submit: function (event) {
        this.setAsLoading();
        event.preventDefault();
        if(this.isLimited){
          if (this.customer && this.customer.verified) {
            this.checkoutProcess();
          } else {
            takhfifan.eventHub.trigger(
              'dc:verifyPhoneNumber',
              {pid: this.model.id, phoneNumber: this.customer.number});
          }
        } else {
          this.checkoutProcess();
        }

        takhfifan.eventHub.trigger('dc:getDiscount',
          {productID: this.model.id, vendorId: this.vendorId});
      },

      disable: function () {
        this.$loadingWrapper.addClass('dc-page__deals-list__closed');
        this.$btn.addClass('dc-item__btn--disable');
        this.$btn.text('به پایان رسید');
        this.$groupedExtBuyButton.append('<a class="dc-subscribe-notify-btn btn btn-blue tkh-dc-subscribe-box__notify-btn" href="javascript:void(0)" data-id="'+this.model.id+'">موجود شد به من اطلاع بده</a>"');
        this.undelegateEvents();
        takhfifan.eventHub.trigger('sticky:update');
      },

      enable: function(){
        if(this.customer && this.model.has('seconds')){
          this.$loadingWrapper.removeClass('loading-view');
          this.delegateEvents();
        }
      },

      setAsLoading: function () {
        this.$loadingWrapper.addClass('loading-view');
        this.undelegateEvents();
      },

      removeLoading: function () {
        this.$loadingWrapper.removeClass('loading-view');
        this.undelegateEvents();
      }
    })
  });

